import api from '../api/axios';

export interface User {
  id?: number;
  username: string;
  email: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  role?: any;
  confirmed?: boolean;
  blocked?: boolean;
  preferredLanguage?: 'en' | 'ar' | 'fr' | 'es';
  lastLoginAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface UserProfile {
  id?: number;
  user?: number;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  mobileNumber?: string;
  dateOfBirth?: string;
  gender?: 'male' | 'female' | 'other';
  address?: string;
  city?: string;
  state?: string;
  country?: string;
  postalCode?: string;
  profilePicture?: any;
  nationalID?: string;
  passportNumber?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  emergencyContactRelation?: string;
  department?: number;
  position?: string;
  employeeID?: string;
  hireDate?: string;
  employmentStatus?: 'active' | 'on_leave' | 'suspended' | 'terminated';
  bio?: string;
  notes?: string;
  isActive?: boolean;
}

const UserService = {
  // User management
  getAll: (params?: any) => api.get('/users', { params }),
  getOne: (id: number) => api.get(`/users/${id}`, { params: { populate: '*' } }),
  create: (data: User) => api.post('/users', data),
  update: (id: number, data: Partial<User>) => api.put(`/users/${id}`, data),
  delete: (id: number) => api.delete(`/users/${id}`),
  
  // Get current user
  me: () => api.get('/users/me', { params: { populate: 'role' } }),
  
  // User profiles
  getUserProfiles: (params?: any) => api.get('/user-profiles', { params }),
  getUserProfile: (id: number) => api.get(`/user-profiles/${id}`),
  createUserProfile: (data: UserProfile) => api.post('/user-profiles', { data }),
  updateUserProfile: (id: number, data: Partial<UserProfile>) => api.put(`/user-profiles/${id}`, { data }),
  deleteUserProfile: (id: number) => api.delete(`/user-profiles/${id}`),
  
  // User sessions
  getUserSessions: (userId?: number) => {
    const params = userId ? { 'filters[user][id][$eq]': userId } : {};
    return api.get('/user-sessions', { params });
  },
  
  // Get roles
  getRoles: () => api.get('/users-permissions/roles'),
};

export default UserService;
